export default __webpack_public_path__ + "static/media/background home.b7d78c40.png";